<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Share Page</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="mb-3 row">
    <label for="shareUrl" class="col-md-4 col-form-label">Page URL:</label>
    <div class="col-md-8">
      <div class="input-group">
        <input type="text" class="form-control" id="shareUrl" name="shareUrl" [value]="currentUrl" readonly />
        <button type="button" class="btn btn-outline-secondary" (click)="copy()" title="Copy">
          <i class="bi bi-copy"></i>
        </button>
      </div>
      <span [hidden]="!showCopiedText">Copied!</span>
    </div>
  </div>
  <div class="mb-3 row">
    <label for="qrCode" class="col-md-4 col-form-label">QR Code:</label>
    <div class="col-md-8">
      <eng-qr-code [text]="currentUrl" />
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Close</button>
</div>
